import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom"; 
import {
  Typography, Checkbox, Box
} from '@mui/material';

import {
  calculateRisk,
  generateWellSummary
} from '../../common/functions';

const FpzTableSummaries = ({ selected = 0, isReport = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    selectedTreatmentWells
  } = useSelector(state => state.fpzReducer);
  //console.log('FpzTable selectedTreatmentWells', selectedTreatmentWells, selected, selectedTreatmentWells[selected]);

  const handleVerifyAllOffsetWells = (verified, selectedTreatmentIndex) => {
    const updatedOffsetWells = selectedTreatmentWells[selectedTreatmentIndex]?.offsetWells?.map(offsetWell => ({
      ...offsetWell,
      verified: verified
    }));
    dispatch({
      type: 'SET_OFFSET_WELLS',
      payload: {
        well: selectedTreatmentWells[selectedTreatmentIndex],
        offsetWells: updatedOffsetWells
      }
    });
  };

  const handleVerifyOffsetWell = (offsetWell, idx, verified, selectedTreatmentIndex) => {
    dispatch({
      type: 'UPDATE_OFFSET_WELL',
      payload: {
        well: selectedTreatmentWells[selectedTreatmentIndex],
        offsetWell: { ...offsetWell, verified: verified },
        index: idx,
      }
    });
  };

  const renderTreatmentTable = (treatmentWell, selectedIndex) => (
    <Box key={treatmentWell.unique_identifier || selectedIndex} mb={4}>
      <div>
        <strong> 
          {treatmentWell.unique_identifier || `Well ${selectedIndex + 1}`}
        </strong>
      </div>
      <div><strong>Operator:</strong> {treatmentWell?.operator}</div>
      <div><strong>Well Name:</strong> {treatmentWell?.surface_location || ''}{`${treatmentWell.lease_name || ''} ${treatmentWell.well_name || ''} ${treatmentWell.well_number || ''}`}</div>
      <div><strong>TVD:</strong> {treatmentWell?.tvd}</div>
      <table border="1" cellPadding="6" style={{ borderCollapse: 'collapse', width: '100%' }}>

        <tbody>
          {treatmentWell?.offsetWells?.filter(well => !isReport || well?.verified)?.map((well, idx) => {
            const isTreatment = (well?.unique_identifier === treatmentWell?.unique_identifier);
            const type = isTreatment ? 'Treatment' : 'Offset';
            const verticalDiff = (treatmentWell?.tvd || 0) - (well?.tvd || 0);
            const risk = calculateRisk({
              distanceM: well?.distance,
              verticalDiffM: verticalDiff,
              statusText: well?.status
            });
            const summary = generateWellSummary({ ...well, type, verticalDiff }, treatmentWell, calculateRisk);
            return (
              <tr key={idx} style={{ backgroundColor: isTreatment ? 'lightblue' : risk.color }}>
                <td width="10%">{idx + 1}</td>
                <td width="30%">
                  <div>{well?.operator}</div>
                  <div>Surface loc: {well?.status}</div>
                  <div>UWI: {well?.unique_identifier}</div>
                </td>
                <td>
                  {summary}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Box>
  );
  

  return (
    <Box>
      {typeof selected === 'number'
        ? renderTreatmentTable(selectedTreatmentWells[selected], selected)
        : selectedTreatmentWells.map((treatmentWell, index) => (
          <>
            {renderTreatmentTable(treatmentWell, index)}
          </>
          ))}
    </Box>
  );
};

export default FpzTableSummaries;
